const check = "/user/auth/login";
const login = "/user/auth/login/check";
const resend = "/user/auth/resend-otp";
const password = "/user/profile/update/password";
const email = "/user/profile/update/email";
const dashboard = "/user/dashboard";
const invoices = "/user/invoices";
const orders = "/user/orders";
// invoices

export { check, login, resend, email, password, dashboard, invoices, orders };
